import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/management/trash_red.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-6c257ea0")

_pushScopeId("data-v-6c257ea0")
const _hoisted_1 = { class: "orders genericPadding hasHeader" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  style: {"width":"24px"}
}, null, -1)
const _hoisted_8 = { class: "fs_18 greyBlue d-block fw_700" }
const _hoisted_9 = { class: "fs_13 greyBlue d-block ln_12 mt-2" }
const _hoisted_10 = { class: "footerInformationContainer" }
const _hoisted_11 = { class: "fs_13 greyBlue ms-1" }
const _hoisted_12 = { class: "d-flex align-items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/profile/' + _ctx.$store.state.user.identifier)))
      }, [
        _hoisted_3
      ]),
      _createVNode(_component_localized_text, {
        class: "fs_12 greyBlue",
        localizedKey: "app_imieiordini",
        text: "I miei ordini"
      }),
      _hoisted_4
    ]),
    (_ctx.orders.length == 0)
      ? (_openBlock(), _createBlock("p", _hoisted_5, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_nessunordineeffettuato",
            text: "Nessun ordine effettuato",
            class: "fs_14 grey d-block text-center"
          })
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orders, (order, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "orderContainer mb-3",
              key: index
            }, [
              _createVNode("div", {
                class: "d-flex justify-content-end",
                onClick: ($event: any) => (_ctx.deleteOrder(order.orderIdentifier))
              }, [
                _hoisted_7
              ], 8, ["onClick"]),
              _createVNode("div", {
                onClick: ($event: any) => (_ctx.orderDetail(order.orderIdentifier))
              }, [
                _createVNode("span", _hoisted_8, "#" + _toDisplayString(order.orderNumber), 1),
                _createVNode("span", _hoisted_9, [
                  _createVNode(_component_localized_text, {
                    localizedKey: 'app_da:',
                    text: 'Da: '
                  }),
                  _createTextVNode(" " + _toDisplayString(order.communityTitle), 1)
                ]),
                _createVNode("div", _hoisted_10, [
                  _createVNode("span", _hoisted_11, " € " + _toDisplayString(_ctx.$filters.currency(order.totalPrice)), 1),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("span", {
                      class: ["circle", order.orderStatus == 0 ? 'pending' : 'closed']
                    }, null, 2),
                    (order.orderStatus == 0)
                      ? (_openBlock(), _createBlock(_component_localized_text, {
                          key: 0,
                          class: "fs_9 greyBlue d-block ln_12",
                          localizedKey: "app_dapagare",
                          text: "Da pagare"
                        }))
                      : (order.orderStatus == 1)
                        ? (_openBlock(), _createBlock(_component_localized_text, {
                            key: 1,
                            class: "fs_9 greyBlue d-block ln_12",
                            localizedKey: "app_pagato",
                            text: "Pagato"
                          }))
                        : (_openBlock(), _createBlock(_component_localized_text, {
                            key: 2,
                            class: "fs_9 greyBlue d-block ln_12",
                            localizedKey: "app_concluso",
                            text: "Concluso"
                          }))
                  ])
                ])
              ], 8, ["onClick"])
            ]))
          }), 128))
        ]))
  ]))
})